// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ed4ed544","703":"ed51188f"}[chunkId] + ".chunk.js";
};